import { ESG, ESGPillar, ESGType } from '../esg/esg.types';

export interface ESGLevelStepCondition {
    operator: ESGLevelOperator;
    value: any;
}

export interface ESGLevelStep {
    conditions: ESGLevelStepCondition[];
}

export interface ESGLevel {
    _id?: string;
    _esg: ESG;
    required: boolean;
    levels: (ESGLevelStep | null)[];
}

export enum ESGLevelOperator {
    EQUAL = 'EQUAL',
    NOT_EQUAL = 'NOT_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
    LESSER_THAN = 'LESSER_THAN',
    LESSER_THAN_OR_EQUAL = 'LESSER_THAN_OR_EQUAL',
    BLANK = 'BLANK',
    NOT_BLANK = 'NOT_BLANK',
    INCLUDE = 'INCLUDE',
}

export enum FormResponsesStatus {
    CREATED = 'CREATED',
    IN_PROGRESS = 'IN_PROGRESS',
    SUBMITTED = 'SUBMITTED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
}

export const ESGLevelOperatorLabels: Record<ESGLevelOperator, string> = {
    [ESGLevelOperator.EQUAL]: '=',
    [ESGLevelOperator.NOT_EQUAL]: '≠',
    [ESGLevelOperator.GREATER_THAN]: '>',
    [ESGLevelOperator.GREATER_THAN_OR_EQUAL]: '≥',
    [ESGLevelOperator.LESSER_THAN]: '<',
    [ESGLevelOperator.LESSER_THAN_OR_EQUAL]: '≤',
    [ESGLevelOperator.BLANK]: 'Is Blank',
    [ESGLevelOperator.NOT_BLANK]: 'Is Not Blank',
    [ESGLevelOperator.INCLUDE]: 'Include',
};

export interface FindEsgLevelQuery {
    type?: ESGType[];
    pillar?: ESGPillar[];
    _category?: string[];
    // esgId?: string;

    search?: string;
}

class FindEsgLevelPaginationDto {
    page = 1;
    perPage = 50;
    sort!: string;
    order!: string;
}

export class FindEsgLevelDto {
    query?: FindEsgLevelQuery;
    pagination?: FindEsgLevelPaginationDto;

    constructor(
        pagination?: FindEsgLevelPaginationDto,
        query?: FindEsgLevelQuery
    ) {
        this.query = query;

        if (pagination) {
            this.pagination = pagination;
        }
        //  else {
        //     this.pagination = new FindEsgPaginationDto();
        // }
    }
}
